const wowApp = require('angular').module('oly.common');

wowApp.filter('paragraphize', [require('./paragraphize')]);
wowApp.filter('sentenceCase', [require('./oly-apply-sentence-case')]);



// WEBPACK FOOTER //
// ./src/olycommon/filters/index.js